// extracted by mini-css-extract-plugin
export default {"navbar":"MainHeader_navbar__arHMu","link":"MainHeader_link__SarGo"};